<template>
    <div v-if="loggedIn">
         <form @submit.prevent="submitComment" class="card p-3 mt-5 reply">
            <div class="input-group">
                 <textarea
                    type="text"
                    v-model.trim="reply"
                    class="form-control"
                    placeholder="Write a comment..."
                    rows="1"
                    required
                    @keyup.enter="submitComment"
                ></textarea>
                <div class="input-group-append align-items-center">
                   <button type="submit" class="btn btn-secondary">
                        Send
                    </button>
                </div>
            </div>
        </form>
         <div class="comments">
             <div v-for="comment in comments" :key="comment.id" class="card mt-4">
                <template v-if="isUserAllowedToDelete(comment.author.id)">
                    <button type="button" aria-label="Close" class="close" @click.prevent="deleteComment(comment.id)">×</button>
                </template>
                <div>
                    <member-info-card class="member" :member="comment.author"></member-info-card>
                </div>
                <div class="comment">
                    <p>{{ comment.content }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $auth from "@/services/auth.js";
import MemberInfoCard from '@/components/global/MemberInfoCard';

export default {
    name: 'comments',

    components: {
        MemberInfoCard
    },

    props: ['comments'],

    data() {
        return {
            reply: '',
            loggedIn: false,
            user: {}
        }
    },

    async beforeCreate() {
        var user = await $auth.user()
        if(user){
            this.loggedIn = true
            this.user = user
        }
    },

    methods: {
        submitComment() {
            if(this.reply != '') {
                this.$emit('submit-comment', this.reply, this.user);
                this.reply = '';
            }
        },

        deleteComment(commentId) {
            this.$bvModal.msgBoxConfirm('Are you sure you want to delete?', {
                title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'Delete',
                cancelVariant: 'primary',
                cancelTitle: 'Cancel',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                if(value == true) this.$emit('delete-comment', commentId);
            });
        },

        isUserAllowedToDelete(authorId) {
            return this.user && this.user.id === authorId;
        },
    },
}
</script>

<style lang="scss" scoped>
    .card {
        padding: 24px;

        .form-control {
            background-color: #ffffff;
            border-radius: 0;
            border: none;
            padding: 10px;
        }

        .input-group {
            @include media-breakpoint-down(sm) {
                display: block;
                width: 100%;
            }
        }

        .input-group-append .btn {
            margin-left: 30px;
            height: 40px;
            border-radius: 30px;
            padding: 0 10px;
            min-width: 125px;

            @include media-breakpoint-down(sm) {
                display: block;
                margin: 10px 0 0 auto;
            }
        }
    }
    .member /deep/ {
        .picture {
            width: 45px;
            height: 45px;
        }
        h3 {
            font-size: 16px;
        }

        h6 {
            font-size: 14px;
        }

        .social-media-links {
            display: none;
        }
    }

    .comment {
        font-size: 15px;
        line-height: 24px;
        color: #505B64;
        margin-top: 10px;

        p {
            margin-bottom: 0;
        }
    }

    button.close {
        position: absolute;
        z-index: 2;
        right: 12px;
        top: 10px;
        font-size: 30px;
        outline: none;
    }
</style>
